var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8088",
    "data-name": "Group 8088",
    transform: "translate(-5 -4.969)",
    opacity: 0.997
  }, /*#__PURE__*/React.createElement("g", {
    id: "field"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43009",
    "data-name": "Path 43009",
    d: "M9,5.969a3,3,0,0,0-3,3v22a3,3,0,0,0,3,3H31a3,3,0,0,0,3-3v-22a3,3,0,0,0-3-3H9m0-1H31a4,4,0,0,1,4,4v22a4,4,0,0,1-4,4H9a4,4,0,0,1-4-4v-22A4,4,0,0,1,9,4.969Z",
    fill: "#bababa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "color",
    d: "M18.5,22.055l7.293-7.293,1.414,1.414L18.5,24.883l-4.707-4.707,1.414-1.414Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2a6636f9d8247ab622b04caeba3e838a.svg";
export { ForwardRef as ReactComponent };